<template>
    <div>
        <config-main-title>
            Editor de Dashboard 
            <span class="badge badge-secondary small" v-if="id">#{{ id }}</span>
            <span class="badge badge-primary small" v-else>Novo</span>
        </config-main-title>

        <az-empty-state v-if="carregando" />

        <template v-else> 

            <div class="card" v-if="acesso_disponivel">
                <div class="card-header d-flex justify-content-between">
                    <div class="h4 mb-0">
                        Informações
                    </div>
                    <div v-if="dados.id">
                        <button class="btn btn-outline-secondary mr-2" type="button" disabled @click="download()" data-toggle="tooltip" data-placement="top" title="Download">
                            <i class="fas fa-download"></i>
                        </button>
                        <button class="btn btn-outline-secondary mr-2" type="button" disabled @click="upload()" data-toggle="tooltip" data-placement="top" title="Upload">
                            <i class="fas fa-upload"></i>
                        </button>
                        <button type="button" class="btn btn-outline-secondary" @click="acessos()" title="Acessos">
                            <i class="fas fa-user-lock"></i>
                        </button>
                    </div>
                </div>

                <div class="card-body">

                    <div class="form-row">
                        <div class="col col-12 col-md-9">
                            <az-input 
                                placeholder="Informe o título do dashboard"
                                :validate="validate"
                                required
                                v-model="dados.title" />
                        </div>

                        <div class="col col-12 col-md-3">
                            <az-input 
                                label="Ativo"
                                type="checkbox-group"
                                :validate="validate"
                                v-model="dados.active" />
                        </div>
                    </div>
                    
                    <az-input 
                        v-if="false"
                        label="Descrição"
                        type="textarea"
                        rows="3"
                        :validate="validate"
                        v-model="dados.descr" />

                    <div class="form-row">
                        <div class="col col-12">
                            <az-input
                                v-if="!id"
                                label="Acesso"
                                type="select"
                                :optionsList="[
                                    {id: 'M', search: 'Acessível inicialmente somente para mim'},
                                    {id: 'T', search: 'Acessível inicialmente para todos os usuários'},
                                ]"
                                optionsData="id"
                                v-model="dados.acesso" />
                        </div>
                    </div>

                    <ul class="nav nav-tabs mt-3" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="nav-link active" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Composição</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Parâmetros</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">JSON</a>
                        </li>
                    </ul>

                    <div class="tab-content" id="myTabContent">
                        <!-- Composição -->
                        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">

                            <div class="card-body" v-if="dados.id">

                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Título</th>
                                            <th>Tipo</th>
                                            <th>Fonte</th>
                                            <th>Largura</th>
                                            <th>Ordem</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(dsi, idx) in dados.dashboard_items" :key="idx">
                                            <td>
                                                <a href="#" @click.prevent="editar_item(dsi)" class="card-link">
                                                    {{ dsi.title }}
                                                </a>
                                            </td>
                                            <td>{{ dsi.dashboard_item_type.description }}</td>
                                            <td>
                                                <span v-if="dsi.query">
                                                    <a href="#" @click.prevent="editar_relatorio(dsi.query)" class="card-link">
                                                        {{ dsi.query.title }}
                                                    </a>
                                                </span>
                                            </td>
                                            <td>{{ dsi.col_width }}</td>
                                            <td>{{ dsi.order }}</td>
                                            <td>{{ dsi.active ? 'Ativo' : 'Inativo' }}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <button type="button" class="btn btn-outline-primary btn-sm" @click="incluir_parte()">
                                    <i class="fas fa-plus"></i>
                                </button>

                            </div>

                        </div>

                        <!-- Parâmetros -->
                        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                            
                            <table class="table table-striped mt-3">
                                <thead>
                                    <tr v-if="dados.config && dados.config.parms">
                                        <td>Selecionados</td>
                                        <td>
                                            <ul>
                                                <li v-for="(parm, ipx) in dados.config.parms" :key="ipx">
                                                    <template v-if="parm.query_id">
                                                        <router-link :to="{ path: '/relatorio/parm.query_id' }" v-if="parm.query_id">
                                                            #{{ parm.query_id }}
                                                        </router-link>
                                                        <i class="fas fa-caret-right mx-2"></i>
                                                    </template>

                                                    {{ parm.parm }}
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(item, iix) in dados.dashboard_items">
                            
                                        <template v-if="item.query && item.query.config && item.query.config.parms">
                                        
                                            <tr :key="iix">
                                                <td width="30%">
                                                    {{ item.title }} 
                                                </td>
                                                <td width="70%">
                                                    
                                                    <div class="form-group" v-for="(parm, ipx) in item.query.config.parms" :key="ipx">
                                                        <input class="mr-2" type="checkbox" v-model="parms_selected[':periodo']" v-if="parm.slice(0,8) == ':periodo'">
                                                        <input class="mr-2" type="checkbox" v-model="parms_selected[get_config_parm(item.query, parm, 'title')]" v-else>

                                                        {{ get_config_parm(item.query, parm, 'title') }}

                                                        <i class="fas fa-caret-right mx-2"></i>

                                                        <router-link :to="{ path: '/relatorio/' + item.query.id }">
                                                            #{{ item.query.id }}
                                                        </router-link>
                                                        
                                                        <i class="fas fa-caret-right mx-2"></i>

                                                        <span class="text-muted">
                                                            {{ parm }}
                                                        </span>
                                                        
                                                    </div>

                                                </td>
                                            </tr>

                                        </template>

                                    </template>

                                    <pre v-if="false">{{ parms_selected }}</pre>

                                </tbody>

                            </table>

                        </div>

                        <!-- JSON -->
                        <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                            <pre class="mt-3 alert alert-info">{{ dados }}</pre>
                        </div>
                    </div>

                </div>

            </div>

            <br><br><br>

            <template v-if="false">
                <hr>
                <pre class="alert alert-info" v-if="false">{{ relatorios }}</pre>
                <pre class="alert alert-warning">{{ dados }}</pre>
            </template>

            <edicao-acessos ref="acessos" v-if="dados.id" />

            <nav class="navbar fixed-bottom navbar-light bg-light">
                <span class="navbar-brand" href="#">
                    {{ dados.title }}
                </span>
                <div class="mr-3 mr-md-0">
                    <az-submit @click="atualizar ()">
                        {{ id ? 'Atualizar' : 'Incluir' }}
                    </az-submit>
                </div>
            </nav>

        </template>

        <draggable />

        <!-- Modal Item Dashboard -->
        <div class="modal fade" id="itemDashModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="ds_item">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Item
                            <span class="badge badge-secondary">{{ ds_item.id ? '#' + ds_item.id : 'Novo' }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-8">
                                <az-input
                                    sizing="sm"
                                    placeholder="Informe o título do item"
                                    :validate="validate"
                                    required
                                    v-model="ds_item.title" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Ativo"
                                    v-model="ds_item.active" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Tipo"
                                    type="select"
                                    :optionsList="dados.types"
                                    optionsDisplay="description"
                                    optionsData="id"
                                    :validate="validate"
                                    required
                                    v-model="ds_item.dashboard_item_type_id" 
                                    @input="selecionar_tipo()" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Largura"
                                    placeholder="Informe a largura do item"
                                    type="select"
                                    :optionsList="larguras"
                                    optionsData="id"
                                    :validate="validate"
                                    required
                                    v-model="ds_item.col_width" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    label="Ordem"
                                    placeholder="Ordem de Exibição..."
                                    type="number"
                                    :validate="validate"
                                    required
                                    v-model="ds_item.order" />
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Informações"
                                    placeholder="Informações sobre o item..."
                                    type="textarea"
                                    rows="2"
                                    v-model="ds_item.info" />
                            </div>
                        </div>

                        <template v-if="ds_item.dashboard_item_type && ds_item.dashboard_item_type.config">
                            <div class="form-row">
                                <div class="col col-12" :class="( campo.type == 'model' || campo.type == 'grafico' ) ? 'col-md-8' : 'col-md-4'" v-for="(campo, icx) in ordenacao(ds_item.dashboard_item_type.config, 'ordem')" :key="icx">
                                    <az-input
                                        v-if="campo.type == 'model' && campo.model == 'Query'"
                                        sizing="sm"
                                        :label="campo.title"
                                        :validate="validate"
                                        type="select"
                                        :optionsList="relatorios"
                                        optionsData="id"
                                        optionsDisplay="title"
                                        v-model="ds_item.config[campo.name]" />

                                    <az-input
                                        v-else-if="campo.type == 'oper'"
                                        sizing="sm"
                                        :label="campo.title"
                                        :validate="validate"
                                        type="select"
                                        placeholder="Selecione..."
                                        :optionsList="[
                                            { id: 'sum', search: 'Totalizar' }, 
                                            { id: 'avg', search: 'Cálcular Média' }, 
                                            { id: 'max', search: 'Máximo' }, 
                                            { id: 'min', search: 'Mínimo' }, 
                                            { id: 'rel', search: 'Relação' }, 
                                        ]"
                                        optionsData="id"
                                        optionsDisplay="search"
                                        v-model="ds_item.config[campo.name]" />

                                    <az-input
                                        v-else-if="campo.type == 'col'"
                                        sizing="sm"
                                        :label="campo.title"
                                        :validate="validate"
                                        type="select"
                                        :optionsList="( relatorio && relatorio.config && relatorio.config.cols ) ? relatorio.config.cols : []"
                                        optionsData="column_name"
                                        optionsDisplay="title"
                                        v-model="ds_item.config[campo.name]" />

                                    <az-input
                                        v-else-if="campo.type == 'grafico'"
                                        sizing="sm"
                                        :label="campo.title"
                                        :validate="validate"
                                        type="select"
                                        :optionsList="( relatorio && relatorio.config && relatorio.config.graphs ) ? relatorio.config.graphs : []"
                                        optionsData="title"
                                        optionsDisplay="title"
                                        v-model="ds_item.config[campo.name]" />

                                    <az-input
                                        v-else-if="campo.type == 'model'"
                                        sizing="sm"
                                        :label="campo.title"
                                        :validate="validate"
                                        v-model="ds_item.config[campo.name]" />

                                    <az-input
                                        v-else-if="campo.type == 'icone'"
                                        :icon="ds_item.config[campo.name]"
                                        placeholder="Ícone do Fontawesome"
                                        sizing="sm"
                                        :label="campo.title"
                                        :validate="validate"
                                        v-model="ds_item.config[campo.name]" />

                                    <az-input
                                        v-else-if="campo.type == 'percentual'"
                                        sizing="sm"
                                        :label="campo.title"
                                        :validate="validate"
                                        type="select"
                                        :optionsList="[
                                            { id: 1, search: 'Sim' },
                                            { id: 0, search: 'Não' },
                                        ]"
                                        optionsData="id"
                                        v-model="ds_item.config[campo.name]" />

                                    <az-input
                                        v-else-if="campo.type == 'color'"
                                        placeholder="Cor"
                                        sizing="sm"
                                        :label="campo.title"
                                        :validate="validate"
                                        type="select"
                                        :optionsList="cores"
                                        optionsData="id"
                                        v-model="ds_item.config[campo.name]">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend" v-if="ds_item.config[campo.name]">
                                                <span class="input-group-text" :class="'text-' + ds_item.config[campo.name]">
                                                    <i class="fa-solid fa-square"></i>
                                                </span>
                                            </div>
                                        </template>
                                    </az-input>

                                    <az-input
                                        v-else
                                        sizing="sm"
                                        :label="campo.title"
                                        :type="campo.type"
                                        :validate="validate"
                                        v-model="ds_item.config[campo.name]" />

                                    <!-- Relação -->
                                    <az-input
                                        v-if="( campo.type == 'oper' && ds_item.config[campo.name] == 'rel' )"
                                        sizing="sm"
                                        label="Coluna Denominador"
                                        :validate="validate"
                                        type="select"
                                        :optionsList="( relatorio && relatorio.config && relatorio.config.cols ) ? relatorio.config.cols : []"
                                        optionsData="column_name"
                                        optionsDisplay="title"
                                        v-model="ds_item.config[campo.name + '-den']" />
                                </div>
                            </div>

                            <template v-if="ds_item.config && ds_item.config.query_id && ds_item.dashboard_item_type_id != 3">

                                <hr>

                                <az-sub-title title="Filtros Fixos" class="mt-3">
                                    <a class="card-link" href="#" @click.prevent="incluir_filtro_relatorio()">
                                        <i class="fas fa-plus mr-2"></i>
                                        Incluir Filtro
                                    </a>
                                </az-sub-title>

                                <template v-if="ds_item.config && ds_item.config.filtros">
                                    <div class="form-row" v-for="(filtro, ifx) in ds_item.config.filtros" :key="ifx">
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                sizing="sm"
                                                placeholder="Selecione a Coluna..."
                                                :validate="validate"
                                                type="select"
                                                :optionsList="( relatorio && relatorio.config && relatorio.config.cols ) ? relatorio.config.cols : []"
                                                optionsDisplay="title"
                                                v-model="filtro.campo">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" @click="remover_filtro_relatorio(ifx)">
                                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-2" v-if="false">
                                            <az-input   
                                                type="select"
                                                placeholder="Selecione..."
                                                sizing="sm" 
                                                :optionsList="[
                                                    { id: '=', search: 'Igual' },
                                                    { id: '<>', search: 'Diferente' },
                                                    { id: 'in', search: 'Lista' },
                                                    { id: 'not in', search: 'Fora da Lista' },
                                                ]"
                                                v-model="filtro.tipo" />
                                        </div>
                                        <div class="col col-12 col-md-6">
                                            <az-input   
                                                sizing="sm"
                                                placeholder="Valor..."
                                                v-model="filtro.valor" />
                                        </div>
                                    </div>

                                    <pre v-if="false">{{ ds_item.config.filtros }}</pre>
                                </template>

                            </template>

                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_item()">{{ !ds_item.id ? 'Incluir' : 'Atualizar' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../cadastros/shared/ConfigMainTitle.vue';
import AzInput from '../shared/forms/AzInput.vue';
import draggable from "vuedraggable";
import AzSubmit from '../util/AzSubmit.vue';
import AzEmptyState from '../util/AzEmptyState.vue';
import EdicaoAcessos from '../cadastros/shared/EdicaoAcessos.vue';
import AzSubTitle from '../util/AzSubTitle.vue';

export default {
    data() { 
        return { 
            dados: { 
                meta: "",
                cols: [],
                filtros: [], 
                title: "",  
                descr: "", 
                graphs: [], 
                ordem: [], 
                query_group_id: 1,
                acesso: "M"
            }, 
            novocampo: "", 
            novofiltro: "", 
            novaordem: "", 
            meta: [], 
            validate: false, 
            drag: false, 
            carregando: true, 
            groups: [], 
            acesso_disponivel: true, 
            listas: null, 
            ds_item: null, 
            relatorios: null, 
            larguras: [
                { id: 1, search: '1: 8%' },
                { id: 2, search: '2: 17%' },
                { id: 3, search: '3: 25%' },
                { id: 4, search: '4: 33%' },
                { id: 5, search: '5: 42%' },
                { id: 6, search: '6: 50%' },
                { id: 7, search: '7: 58%' },
                { id: 8, search: '8: 67%' },
                { id: 9, search: '9: 75%' },
                { id: 10, search: '10: 83%' },
                { id: 11, search: '11: 92%' },
                { id: 12, search: '12: 100%' },
            ],
            cores: [ 
                { id: 'primary', search: 'azul' },
                { id: 'secondary', search: 'cinza' },
                { id: 'success', search: 'verde' },
                { id: 'danger', search: 'vermelho' },
                { id: 'warning', search: 'amarelo' },
                { id: 'info', search: 'azul ciano' },
                { id: 'light', search: 'branco' },
                { id: 'dark', search: 'preto' },
            ],
            parms_selected: {},
        }
    },

    components: { 
        ConfigMainTitle,
        AzInput, 
        draggable, 
        AzSubmit, 
        AzEmptyState, 
        EdicaoAcessos,
        AzSubTitle, 
    },

    props: ['id'],

    computed: { 
        lista_campos: function () { 
            if ( !_.get(this.dados, 'meta.config.cols') ) { 
                return [];
            }

            return _.orderBy(
                    this.dados.meta.config.cols, 
                    (item) => item.title ? item.title.toUpperCase() : '?'
                );
        },

        lista_variaveis: function () { 
            return this.dados.cols.filter(item => item.value == 'value' || ( item.action && item.action != 'L' && item.action != 'Q' ))
                .map(item => { 
                    return { 
                        id: item.name,
                        search: item.title ? item.title : '[' + item.name + ']', 
                    };
                });
        },

        lista_categorias: function () { 
            return this.dados.cols.filter(item => item.value != 'value' && item.action && ( item.action == 'L' || item.action == 'Q' ))
                .map(item => { 
                    return { 
                        id: item.name,
                        search: item.title, 
                    };
                });
        },

        relatorio: function () { 
            if ( !this.ds_item || !this.ds_item.config || !this.ds_item.config.query_id ) { 
                return null;
            }

            return this.relatorios.find(item => item.id == this.ds_item.config.query_id);
        },
    },

    methods: { 
        remover_filtro_relatorio(idx) { 
            this.ds_item.config.filtros.splice(idx, 1);
            this.$forceUpdate();
        },

        incluir_filtro_relatorio() { 
            if ( !this.ds_item.config.filtros ) { 
                this.ds_item.config.filtros = [];
            }

            this.ds_item.config.filtros.push({ 
                campo: "", 
                tipo: "",
                valor: "", 
            });

            this.$forceUpdate();
        },

        get_config_parm(item, parm, info) { 

            if ( !item.config )
                return;

            if ( item.config.config_parms && item.config.config_parms[parm] ) {
                return _.get(item.config.config_parms[parm], info);
            }
            
            return;

        },

        editar_relatorio (query) { 
            this.$router.push({ path: '/relatorio/editor/' + query.id });
        },

        atualizar_item () { 
            this.$util.atualizar(this, { 
                service: 'dashboards',
                func: 'dash_store_items',
                dados: this.ds_item,
                toast: true, 
                modal: 'itemDashModal', 
                reload: true, 
            });
        },

        ordenacao(lista, campo_ordem) { 
            return _.orderBy(
                _.map(
                    lista, 
                    (campo, name) => { 
                        return { 
                            ...campo, 
                            name: name, 
                        };
                    }
                ), 
                campo_ordem
            );
        },

        selecionar_tipo () { 
            if ( this.ds_item.dashboard_item_type_id ) { 

                let item_type = this.dados.types.find(item => item.id == this.ds_item.dashboard_item_type_id);

                this.ds_item.dashboard_item_type = item_type;

            }
        },

        editar_item (dsi) { 
            this.validate = false;

            this.ds_item = _.cloneDeep(dsi);

            $('#itemDashModal').modal('show');
        },

        incluir_parte () { 
            this.validate = false;
            this.ds_item = null;

            this.$nextTick(() => { 

                this.ds_item = { 
                    dashboard_id: this.dados.id,
                    title: "", 
                    dashboard_item_type_id: 2,
                    col_width: 6, 
                    order: 50, 
                    config: {
                        filtros: [], 
                    }, 
                    active: true, 
                    info: "", 
                    dashboard_item_type: null, 
                };

                $('#itemDashModal').modal('show');

            });
        },

        download () { 
            $('[data-toggle="tooltip"]').tooltip('hide');
            
            var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.dados));
            var downloadAnchorNode = document.createElement('a');
            downloadAnchorNode.setAttribute("href",     dataStr);
            downloadAnchorNode.setAttribute("download", "relatorio.json");
            document.body.appendChild(downloadAnchorNode); 
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
        },

        upload() { 
            $('[data-toggle="tooltip"]').tooltip('hide');

            var downloadAnchorNode = document.createElement('input');
            downloadAnchorNode.setAttribute("type", "file");
            downloadAnchorNode.setAttribute("class", "d-none");
            downloadAnchorNode.onchange = () => { this.posUpload(downloadAnchorNode); };
            document.body.appendChild(downloadAnchorNode); 
            downloadAnchorNode.click();
        },

        posUpload(el) { 
            var file = el.files[0];

            if (file) {

                var reader = new FileReader();
                
                reader.readAsText(file, "UTF-8");
                
                reader.onload = (evt) => {
                    let info = JSON.parse(evt.target.result); 

                    if ( !info.meta ) { 
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: "Arquivo inválido. Não é um relatório da área selecionada.",
                            life: 3000
                        });

                        return;
                    } else if ( info.meta.id != this.dados.meta.id ) { 
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: "Arquivo inválido. Não é um relatório da área selecionada: " + info.meta.name + ". (" + info.meta.id + "x" + this.dados.meta.id + ")",
                            life: 3000
                        });

                        return;
                    }

                    info.id = this.dados.id; 
                    info.title = this.dados.title ? this.dados.title : info.title;
                    info.meta = this.dados.meta;
                    info.descr = this.dados.descr ? this.dados.descr : info.descr;

                    this.dados = _.cloneDeep(info);

                    this.$toast.add({
                        severity: "success",
                        summary: "Atenção",
                        detail: "Arquivo carregado.",
                        life: 3000
                    });

                }

                reader.onerror = function () {
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Falha lendo arquivo.",
                        life: 3000
                    });
                }

            }

        },

        acessos() { 
            this.$refs.acessos.abrir('App\\Query', this.dados.id);
        },
        
        remover () { 
            if ( !confirm('Confirma remover esse relatório da base?') )
                return;

            this.$util.atualizar(this, { 
                service: 'relatorios',
                func: 'remover_meta',
                dados: { 
                    id: this.id 
                },
                toast: true, 
                callback: () => { 
                    this.$router.push({ path: '/relatorios' });
                }
            });
        },

        tratar_opcoes (lista, campo) { 
            if ( this.listas && _.get(this.listas, campo.name) ) { 
                lista = _.get(this.listas, campo.name);
            }

            return _.map(lista, (item, chave) => { 
                if ( item.data && item.display ) { 
                    return { 
                        id: item.data,
                        search: item.display,
                    };
                }

                return { 
                    id: chave,
                    search: item
                };
            });
        },

        removerOrdem (idx) { 
            this.dados.ordem.splice(idx,1);
        },

        incluir_ordem () { 

            if ( !this.novaordem ) 
                return;

            if ( !this.dados.ordem )
                this.dados.ordem = [];

            let indice = this.dados.cols.findIndex(item => item.column_name == this.novaordem.column_name);

            this.dados.ordem.push({ 
                index: indice,
                direc: 'ASC',
            });

            this.$nextTick(() => { 
                this.novaordem = "";
            });

        },

        incluir_grafico () { 

            this.dados.graphs.push({ 
                title: "", 
                type: "bar",
                var: "",
                category: "", 
                ordem: "value",
                samples: "", 
                series: "", 
                size: "6",
            });

        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'dashboards',
                func: 'store',
                dados: { 
                    ...this.dados,
                    parms_selected: this.parms_selected,
                },
                toast: true, 
                callback: res => { 
                    if ( !this.id && res.id ) { 
                        
                        this.$router.push({ path: '/dashboard/editor/' + res.id });

                        this.$nextTick(() => { 
                            this.load();
                        });

                    } else { 

                        this.$nextTick(() => { 
                            this.load();
                        });

                    }
                }
            });
        },

        removerColuna (idx) { 
            this.dados.cols.splice(idx,1);
        },

        removerGrafico (idx) { 
            this.dados.graphs.splice(idx,1);
        },

        removerFiltro (idx) { 
            this.dados.filtros.splice(idx,1);
        },

        incluir_filtro () { 
            if ( !this.novofiltro )
                return;

            this.dados.filtros.push({
                ...this.novofiltro,
                tipo: "P", 
                operacao: "=",
                valor: "", 
            });

            this.$nextTick(() => { 
                this.novofiltro = "";
            });
        },

        incluir_campo (formula = false) { 
            let info;

            if ( formula ) { 
                info = { 
                    name: 'form.' + ( '.' + Math.random() ).slice(4,10),
                    formula: true, 
                    value: 'value',
                    title: '[formula]',
                };
            } else if ( !this.novocampo ) { 
                return;
            } else { 
                info = this.novocampo;
            }

            this.dados.cols.push({
                ...info,
                action: "L", 
                column_name: 'col.' + ( '.' + Math.random() ).slice(4), 
            });

            this.$nextTick(() => { 
                this.novocampo = "";
            });
        },

        load () { 

            if ( !this.id ) { 

                this.dados = { 
                    id: null, 
                    title: "", 
                    config: {}
                }
                     
                let breadcrumb; 

                if ( !this.breadcrumb ) { 

                    breadcrumb = [
                        { name: "Relatórios", path: "/relatorios" }
                    ];

                    if ( this.id ) { 

                        breadcrumb.push({
                            name: this.dados.title,
                            path: "/dashboard/" + this.id
                        });

                    }

                } else { 

                    breadcrumb = _.cloneDeep(this.breadcrumb);

                }

                breadcrumb.push({
                    name: 'Configuração de Dashboard',
                    path: "/dashboard/editor/" + this.id
                });

                this.$store.commit("setBreadcrumb", breadcrumb);

                this.carregando = false;

                return;

            }

            this.parms_selected = {};

            this.$store.commit("loading", true);

            let query = {
                q: [
                    {
                        name: 'dashboards.index',
                        id: "meta",
                        parms: { 
                            id: this.id, 
                            edicao: true, 
                        }
                    }
                ]
            };

            this.axios
                .post("/aql?a=dashboards.index.editor", query)
                .then(res => {
                    if (res.data.meta.status == 200) {

                        if ( this.id ) { 

                            this.dados = res.data.meta.data;

                            if ( this.dados && this.dados.config && this.dados.config.parms ) { 
                                this.dados.config.parms.forEach((element) => {
                                    this.parms_selected[element.parm] = true;    
                                });
                            }
                            
                        } else { 
                            this.dados = { 
                                id: null, 
                                title: "", 
                                config: {}
                            }
                        }

                        let breadcrumb; 

                        if ( !this.breadcrumb ) { 
                            breadcrumb = [
                              { name: "Relatórios", path: "/relatorios" }
                            ];

                            if ( this.id ) { 

                                breadcrumb.push({
                                    name: this.dados.title,
                                    path: "/dashboard/" + this.id
                                });

                            }

                        } else { 

                            breadcrumb = _.cloneDeep(this.breadcrumb);

                        }

                        breadcrumb.push({
                                name: 'Configuração de Dashboard',
                                path: "/dashboard/editor/" + this.id
                            });

                        this.$store.commit("setBreadcrumb", breadcrumb);

                    } else { 

                        this.acesso_disponivel = false; 
                        
                    }
                })
                .finally(() => {
                    this.carregando = false; 
                    this.$store.commit("loading", false);
                });

        },

        carregar_relatorios () { 
            this.$util.loadItem(this, { 
                    service: 'relatorios',
                    func: 'index',
                    parms: { 
                        config_dash: true, 
                        ordem: 'alfa',
                    }
                })
                .then(res => { 
                    this.relatorios = res;
                });
        }
    },

    mounted() { 
        this.carregar_relatorios();
        this.load();
    }
}
</script>